import { jsx as _jsx } from "react/jsx-runtime";
import { Root, Text } from './Hint.styles';

var Hint = function Hint(_ref) {
  var text = _ref.text;
  return _jsx(Root, {
    children: _jsx(Text, {
      children: text
    })
  });
};

export default Hint;